import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const rootEl = document.getElementById("root");

const AppTree = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// If react-snap pre-rendered this route at build time, the #root element
// already contains real DOM. In that case we must hydrate — using createRoot
// on already-rendered HTML wipes it and hurts SEO signal delivery. Otherwise
// (dev, first-run, or a route react-snap did NOT pre-render) do a fresh
// createRoot.
if (rootEl.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootEl, AppTree);
} else {
  ReactDOM.createRoot(rootEl).render(AppTree);
}
